<template>
  <header :class="['lVariation', mode]">
    <div class="lVariation__container">
      <img src="@/assets/img/logo-color.svg" alt="Logo da Finclass" class="lVariation__container-logo" />
      <button v-if="showButton" @click="redirectTo" class="lVariation__container-button">
        {{ button.label }}
      </button>
    </div>
  </header>
</template>

<script>
import { computed, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import useNavigate from '@/composables/useNavigate';

export default {
  name: 'LightVariation',
  props: {
    button: { type: Object, required: true },
  },
  setup(props) {
    const { button } = toRefs(props);
    const router = useRouter();
    const navigate = useNavigate();

    const mode = computed(() => navigate.getQueryParam('mode'));
    const showButton = computed(() => {
      return button.value && button.value.hasOwnProperty('label') && button.value.hasOwnProperty('route');
    });

    const redirectTo = () => {
      let paramsRoute = router.currentRoute.value;
      if (paramsRoute?.params?.slug) {
        paramsRoute.query.offerSlug = paramsRoute?.params?.slug;
      } else {
        paramsRoute = paramsRoute.query;
        if (paramsRoute?.offerSlug) {
          button.value.route.params = { slug: paramsRoute.offerSlug };
        }
      }
      router.push({ ...button.value.route, query: router.currentRoute.value.query });
    };

    return { mode, redirectTo, showButton };
  },
};
</script>

<style lang="scss" scoped>
.lVariation {
  width: 100%;
  min-height: 80px;
  display: flex;
  align-items: flex-end;
  background-color: $white;
  border-bottom: 1px solid $dark-60;

  &.dark {
    background-color: $dark-900;
    border-bottom: none;
  }

  &__container {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-right: 20px;
    padding-left: 20px;

    &-logo {
      width: 106px;
      height: 18px;
      margin-bottom: 10px;
    }

    &-button {
      font-weight: 600;
      font-size: 0.875rem;
      line-height: 140%;
      letter-spacing: -0.005em;
      color: $seer-stone;
    }
  }
}

@media (min-width: 768px) {
  .lVariation {
    min-height: 88px;

    &__container {
      margin-bottom: 28px;
      padding-right: 48px;
      padding-left: 48px;

      &-logo {
        width: 168px;
        height: 28px;
        margin-bottom: 0;
      }

      &-button {
        font-size: 1.125rem;
      }
    }
  }
}
</style>
